import { buildGlobalReferenceContext } from '../../../../context/buildGlobalReferenceContext.mjs';

const [SingleSelectOptionContextProvider, useSingleSelectOptionContext] = buildGlobalReferenceContext("Option");

export { SingleSelectOptionContextProvider, useSingleSelectOptionContext };
//# sourceMappingURL=option-context.mjs.map
